export default "__VITE_ASSET__c721f385__"